var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"spinner"},[_c('font-awesome-icon',{class:_vm.className + ' spin fa-8x',attrs:{"icon":"spinner"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }